<template>
  <div class="sony-bar">
    <a
      href="https://www.sony.com/"
      target="_blank"
      rel="noopener noreferrer nofollow"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 500 88.03"
      >
        <path
          fill="#fff"
          d="M178.13 88C160 88 143.2 82.6 132 72.53a37.85 37.85 0 0 1-12.55-28.59A38.41 38.41 0 0 1 132 15.45C142.4 6 160.8 0 178.13 0c19.17 0 34.52 4.83 46.25 15.47a38.05 38.05 0 0 1 12.38 28.47 39.66 39.66 0 0 1-12.38 28.59C213.45 82.66 196.29 88 178.13 88V76.42c9.61 0 18.53-3.32 24.76-9.52s9.06-13.72 9.06-23c0-8.86-3.11-17.14-9.06-23-6.15-6.05-15.28-9.46-24.76-9.46s-18.65 3.38-24.8 9.46c-5.93 5.87-9 14.18-9 23a32.17 32.17 0 0 0 9 23c6.15 6.13 15.26 9.52 24.8 9.52zM45.75 0c-9.69 0-20.7 1.82-30 6C7.07 9.88 0 16.11 0 26.44A21.18 21.18 0 0 0 5.75 41c2.51 2.32 6.56 6.26 17.14 8.58 4.73 1 14.84 2.61 24.91 3.67s19.83 2 23.83 3.07c3.18.81 8.53 1.91 8.53 7.91s-5.63 7.8-6.61 8.19-7.74 3.49-19.88 3.49A84.54 84.54 0 0 1 30 71.84c-4.53-1.62-9.28-3.75-13.71-9.16A15.73 15.73 0 0 1 13.44 54h-11v30.8h12.22v-4.17a1.74 1.74 0 0 1 2.64-1.5 96.26 96.26 0 0 0 17.88 5.78c6.42 1.34 10.57 2.31 18.55 2.31a79.15 79.15 0 0 0 24.86-3.51 43.39 43.39 0 0 0 14.77-7.29 20.24 20.24 0 0 0 7.91-16.21 22.68 22.68 0 0 0-6.39-15.94A28.13 28.13 0 0 0 87 38.88a58.05 58.05 0 0 0-9.72-3.39C70.94 33.94 56.7 32 49.89 31.32c-7.14-.74-19.53-1.77-24.48-3.3-1.5-.47-4.56-1.92-4.56-5.47 0-2.53 1.4-4.67 4.16-6.4 4.39-2.75 13.25-4.46 22.49-4.46a65.23 65.23 0 0 1 26.06 5.09 28.46 28.46 0 0 1 6.2 3.7 18.64 18.64 0 0 1 6.11 10.22h9.87V3.89h-11V7c0 1-1 2.32-3 1.23C76.78 5.65 62.84.07 45.75 0zm241.49 4.92L341 53.43l-.55-32.66c-.06-4.29-.84-6.08-5.48-6.08h-10.1V4.92h46v9.77H361c-4.72 0-5 1.52-5.08 6.08l.83 62.41H341l-61.93-55.26v39.21c.05 4.27.25 6.28 4.64 6.28h11v9.77h-45.09v-9.77h10.56c3.94 0 3.78-3.76 3.78-6.5V21.14c0-3-.42-6.44-6.6-6.44h-8.56V4.92zm136.11 68.47a21.82 21.82 0 0 0 2.72-.17 3.37 3.37 0 0 0 2.12-1.88 10.94 10.94 0 0 0 .21-2.11V53.78c0-.52 0-.53-.66-1.35s-28.16-32-29.41-33.4c-1.56-1.7-4.3-4.33-8.47-4.33h-9.55V4.92h53.9v9.76h-6.5c-1.5 0-2.5 1.43-1.22 3 0 0 18.14 21.7 18.31 21.93s.32.28.55.07 18.59-21.8 18.73-22a1.87 1.87 0 0 0-1.6-3h-6.67V4.92H500v9.78h-9.87c-3.58 0-5 .66-7.73 3.7l-29.75 33.94a2.1 2.1 0 0 0-.36 1.44v15.44a11 11 0 0 0 .22 2.11 3.33 3.33 0 0 0 2.11 1.88 19.77 19.77 0 0 0 2.7.17h10.09v9.78h-53.62v-9.78z"
        />
      </svg>
      <span class="sr-only">Sony</span>
    </a>
  </div>
</template>

<style lang="scss" scoped>
.sony-bar {
  position: relative;
  z-index: 9;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 36px;
  padding: 0 15px;
  background-color: #000;

  svg {
    width: 70px;
  }

  .sr-only {
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    margin: -1px !important;
    padding: 0 !important;
    overflow: hidden !important;
    white-space: nowrap !important;
    border: 0 !important;
    clip: rect(0 0 0 0) !important;
    clip-path: inset(50%) !important;
  }
}
</style>
